<template>
  <v-row justify="center">
    <v-overlay style="text-align: center;" v-show="$store.state.circularProgress.display">
      <h2 v-html="$store.state.circularProgress.html"></h2>
      <v-progress-circular
        :rotate="-90"
        :size="100"
        :width="15"
        :value="$store.state.circularProgress.value"
        color="primary"
        style="margin-top:20px"
      >
        <strong style="color: white;">{{ $store.state.circularProgress.value }}</strong>
      </v-progress-circular>
    </v-overlay>
  </v-row>
</template>
<script>
export default {};
</script>
